import { render } from "./TheMarketItem.vue?vue&type=template&id=61c7bdec&scoped=true&ts=true"
import script from "./TheMarketItem.vue?vue&type=script&lang=ts"
export * from "./TheMarketItem.vue?vue&type=script&lang=ts"

import "./TheMarketItem.vue?vue&type=style&index=0&id=61c7bdec&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c7bdec"]])

export default __exports__